import React from 'react';
import './index.css';

function AdvancedSearch (props) {

	return (
		<div className="advanced-search">
			<div className="advanced-search__content">
				{props.children}
			</div>
		</div>
	)
}

export default AdvancedSearch;
